package com.eladfinish.bible.contest.di.config

data class DebugInfo(
    val isDebugMode: Boolean,
)
